(() => {
  if (window.O2BrandTypography) return;
  window.O2BrandTypography = true;

  const EXCLUDED =
    '.o2-brand, .header-o2__back-link, script, style, template, textarea, input, select, code, pre, svg, math, [contenteditable]';
  const BRAND = /(^|[^\p{L}\p{N}_]|Moje)O[2₂](?=$|[^\p{L}\p{N}_])/gu;

  function createBrand() {
    const brand = document.createElement('span');
    brand.className = 'o2-brand';
    const digit = document.createElement('span');
    digit.className = 'o2-brand__digit';
    digit.textContent = '2';
    brand.append('O', digit);
    return brand;
  }

  function createTextRun(...children) {
    const run = document.createElement('span');
    run.className = 'o2-brand-text';
    run.append(...children);
    return run;
  }

  function normalizeText(node) {
    const text = node.nodeValue;
    const matches = [...text.matchAll(BRAND)];
    if (!matches.length) return;

    const fragment = document.createDocumentFragment();
    let offset = 0;
    for (const match of matches) {
      fragment.append(text.slice(offset, match.index), match[1], createBrand());
      offset = match.index + match[0].length;
    }
    fragment.append(text.slice(offset));
    // Keep the original text in one layout item so flex/grid preserve its spaces.
    node.replaceWith(createTextRun(fragment));
  }

  function normalize(root) {
    if (root.nodeType !== Node.TEXT_NODE && root.nodeType !== Node.ELEMENT_NODE) return;
    const parent = root.nodeType === Node.TEXT_NODE ? root.parentElement : root;
    if (!root.isConnected || !parent || parent.closest(EXCLUDED)) return;
    if (root.nodeType === Node.TEXT_NODE) {
      if (parent.matches('sub') || root.nextSibling?.nodeName === 'SUB') {
        normalize(parent.matches('sub') ? parent.parentElement : parent);
        return;
      }
      normalizeText(root);
      return;
    }
    // Rich text may already contain O<sub>2</sub>; replace only that brand pair.
    const subs = root.matches('sub') ? [root] : root.querySelectorAll('sub');
    for (const sub of subs) {
      const previous = sub.previousSibling;
      if (sub.closest(EXCLUDED) || previous?.nodeType !== Node.TEXT_NODE || !/^[2₂]$/.test(sub.textContent)) continue;
      const text = previous.nodeValue + sub.textContent;
      if (![...text.matchAll(BRAND)].some((match) => match.index + match[1].length === text.length - 2)) continue;
      const run = createTextRun(previous.nodeValue.slice(0, -1), createBrand());
      previous.remove();
      sub.replaceWith(run);
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          return node.matches(EXCLUDED) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_SKIP;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(normalizeText);
  }

  function init() {
    normalize(document.body);
    const observer = new MutationObserver((records) => {
      const roots = new Set();
      for (const record of records) {
        if (record.type === 'characterData') roots.add(record.target);
        else record.addedNodes.forEach((node) => roots.add(node));
      }
      roots.forEach(normalize);
    });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
